<!-- Search Form Section Begin -->
<div class="search-form">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="search-form-text">
          <div class="{{alouer}} col-lg-2" (click)="active1()" style="cursor: pointer;">
            <i class="fa fa-clock-o fa-lg"></i>
            {{ 'HOME_SEARCH.RENT' | translate }}
          </div>
          <div class="{{avendre}} col-lg-2" (click)="active2()" style="cursor: pointer;">
            <i class="fa fa-money fa-lg"></i>
            {{ 'HOME_SEARCH.SALE' | translate }}
          </div>
        </div>
        <form class="filter-form" #searchForm="ngForm" (ngSubmit)="search(searchForm.value)" id="formId">
          <div class="first-row">
            <select attr.ngModel="{{idcategorie}}" name="categorie" (change)="selectType($event.target.value)"
              id="categorie" class="nice-select" required>
              <option class="current" [value]="0">{{ 'HOME_SEARCH.CATEGORY' | translate }}</option>
              <option class="current" *ngFor="let cat of Categories; let id = index" [value]="cat.idcategorie">
                {{gData.getTranslatedCategoryName(cat.nomcategorie)}}</option>
            </select>
            <select attr.ngModel="{{idtypelogement}}" name="typelogement" (change)="selectSubcat($event.target.value)"
              id="typelogement" class="nice-select">
              <option class="current" [value]="0">{{ 'HOME_SEARCH.PROPERTY_TYPE' | translate }}</option>
              <option (click)="selectType($event.target.value)" class="current" *ngFor="let type of Typelogements"
                [value]="type.idtypelogement">{{gData.getTranslatedPropertyType(type.nomtypelogement)}}</option>
            </select>
            <select attr.ngModel="{{idville}}" name="ville" (change)="selectVille($event.target.value)"
              id="ville" class="nice-select" required>
              <option class="current" [value]="0">{{ 'HOME_SEARCH.CITY' | translate }}</option>
              <option class="current" *ngFor="let ville of Villes" [value]="ville.idville">
                {{ville.nomville}}</option>
            </select>
            <select attr.ngModel="{{idquartier}}" name="quartier" (change)="selectQuartier($event.target.value)"
              id="quartier" class="nice-select">
              <option class="current" [value]="0">{{ 'HOME_SEARCH.DISTRICT' | translate }}</option>
              <option class="current" *ngFor="let quartier of Quartiers" [value]="quartier.idquartier">
                {{quartier.nomquartier}}</option>
            </select>
          </div>
          <div class="second-row">
            <div class="price-range-wrap">
              <div class="price-text">
                <label for="priceRange">{{ 'HOME_SEARCH.DISTANCE' | translate }}: {{mindist}} - {{maxdist}} m</label>
                <ng5-slider [(value)]="mindist" [(highValue)]="maxdist" [options]="optionsdist"></ng5-slider>
              </div>
            </div>

            <div class="price-range-wrap">
              <div class="price-text">
                <label for="priceRange">{{ 'HOME_SEARCH.PRICE_RANGE' | translate }}: {{minValueprix | number}} - {{maxValueprix | number}} FCFA</label>
                <ng5-slider [(value)]="minValueprix" [(highValue)]="maxValueprix" [options]="optionsprix"></ng5-slider>
              </div>
            </div>

            <div class="price-range-wrap">
              <div class="price-text">
                <label for="priceRange">{{ 'HOME_SEARCH.AREA' | translate }}: {{minValuesup}} - {{maxValuesup}} m²</label>
                <ng5-slider [(value)]="minValuesup" [(highValue)]="maxValuesup" [options]="optionssup"></ng5-slider>
              </div>
            </div>
          </div>
          <div class="third-row">
            <button type="submit" class="site-btn" [disabled]="!searchForm.form.valid">{{ 'HOME_SEARCH.SEARCH' | translate }}</button> 
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- Search Form Section End -->